export const scopeTypes = {
    GUEST: 'GUEST',
    REGISTERED: 'REGISTERED',
    AUTHORIZED: 'AUTHORIZED',
    EMPLOYEE: 'EMPLOYEE'
};

export const ALL_SCOPES = [scopeTypes.GUEST, scopeTypes.REGISTERED, scopeTypes.AUTHORIZED];

export const AUTH_TOKEN_HEADER = 'X-Urbn-Auth-Token';
export const URBN_LANGUAGE_HEADER = 'X-Urbn-Language';
export const URBN_CURRENCY_HEADER = 'X-Urbn-Currency';
export const URBN_CHANNEL_HEADER = 'X-Urbn-Channel';
export const URBN_HEADER_GEO_REGION = 'X-Urbn-Geo-Region';
export const URBN_HEADER_DATA_CENTER_ID = 'X-Urbn-Primary-Data-Center-Id';

export const COOKIE_NAME_URBN_LANGUAGE = 'urbn_language';
export const COOKIE_NAME_HAS_ACCEPTED_COOKIES = 'urbn_has_accepted_cookies';
export const COOKIE_NAME_CURRENCY = 'urbn_currency';
export const COOKIE_NAME_SITE_ID = 'urbn_site_id';
export const COOKIE_NAME_INVENTORY_POOL = 'urbn_inventory_pool';
export const COOKIE_NAME_AUTH_PAYLOAD = 'urbn_auth_payload';
export const COOKIE_NAME_CHANNEL = 'urbn_channel';
export const COOKIE_NAME_EDGESCAPE_SITE_ID = 'urbn_edgescape_site_id';
export const COOKIE_NAME_SITE_CHOICE = 'urbn_site_choice';
export const COOKIE_NAME_SITE_ID_OLD = 'siteId';
export const COOKIE_NAME_URBN_IS_LOYALTY = 'urbn_is_loyalty';
export const COOKIE_NAME_URBN_LOYALTY_POINTS = 'urbn_loyalty_points';
export const COOKIE_NAME_SIGNUP_SUCCESS = 'urbn_signup_success';
export const COOKIE_NAME_LOGIN_SUCCESS = 'urbn_login_success';
export const COOKIE_PERSONALIZATION_CONTEXT = 'urbn_personalization_context';
export const COOKIE_NAME_EMAIL_SIGNUP_MARKETING_OPTIN = 'urbn_email_signup_marketing_optin';
export const COOKIE_NAME_COUNTRY = 'urbn_country';
export const COOKIE_NAME_USE_SEARCH_PROVIDER = 'urbn_use_search_provider';
export const COOKIE_NAME_URBN_BYPASS_UNSUPPORTED = 'urbn_bypass_unsupported';
export const COOKIE_NAME_URBN_DEVICE_TYPE = 'urbn_device_type';
export const COOKIE_NAME_IS_WEBVIEW = 'urbn_is_webview';
export const COOKIE_NAME_LOYALTY_BROWSE_EVENT = 'urbn_loyalty_browse_event';
export const COOKIE_NAME_SITE_SWITCH_DISPLAY_AS_MODAL = 'SS_SWITCHMODAL';
export const COOKIE_NAME_HAS_DISMISSED_PRIVACY_NOTICE = 'urbn_has_dismissed_privacy_notice';
export const COOKIE_NAME_URBN_PRIVACY_OPTOUT = 'urbn_privacy_optout';

export const LOGIN_METHOD_SIGNIN = 'SIGNIN';
export const LOGIN_METHOD_SIGNUP = 'SIGNUP';

export const GENDER_TYPES = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    UNKNOWN: 'UNKNOWN'
};

export const AKAMAI_DEVICE_TYPE_COOKIE_VALUES = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE'
};

export const LANDING_PAGE = 'Gateway';

export const SKU_AVAILABILITY_AVAILABLE = '1000';
export const SKU_AVAILABILITY_OUT_OF_STOCK = '1111';
export const SKU_AVAILABILITY_BACKORDERED = '1003';
export const PURCHASABLE_SKU_STATUS_CODES = [
    SKU_AVAILABILITY_AVAILABLE,
    SKU_AVAILABILITY_BACKORDERED
];

export const ALLOWED_SITE_CONTEXT_PATHS = ['en-us', 'en-ca', 'fr-ca', 'en-gb', 'fr-fr', 'de-de'];

export const SKU_AVAILABILITY_DISCONTINUED = '1005';

export const SUBSCRIPTION_ACTIONS = {
    SUBSCRIBE: 'Sub',
    UNSUBSCRIBE: 'Unsub',
    RESUBSCRIBE: 'Resub'
};

export const SOURCES = {
    HELP: 'Help'
};

export const FLAT_RATE_SHIPPING_RESTRICTION_CODES = [
    'FLAT_RATE_A',
    'FLAT_RATE_B'
];

export const CATEGORY_FACET_TYPES = {
    DIVISION: 'division',
    CATEGORY: 'category',
    PRICE: 'price',
    SIZE: 'size',
    COLOR: 'color',
    BRAND: 'brand'
};

export const CATEGORY_REFINEMENT_NAMES = {
    SIZE: 'visualVariants.nonvisualVariants.size',
    COLOR: 'visualVariants.colorwayNames',
    PRICE: 'visualVariants.nonvisualVariants.salePrice',
    REVIEWS: 'tile.reviews.averageRating',
    BRAND: 'tile.product.brand',
    KEYWORDS: 'tile.productkeywords'
};

export const DEFAULT_IMAGE_QUALITY = 80;
export const COOKIE_PAGE_VISITS_COUNT = 'urbn_page_visits_count';
export const COOKIE_INTERSTITIAL_DEFERRED = 'urbn_interstitial_deferred';
export const BAZAARVOICE_ALLOWED_HEADERS = [
    'X-Bazaarvoice-QPM-Allotted',
    'X-Bazaarvoice-QPM-Current',
    'X-Bazaarvoice-QPS-Allotted',
    'X-Bazaarvoice-QPS-Current',
    'X-Bazaarvoice-Quota-Allotted',
    'X-Bazaarvoice-Quota-Current',
    'X-Bazaarvoice-Quota-Reset',
    'X-Requested-With',
    'X-CSRF-Token'
];
export const ORDER_CANCEL_MODAL_SUBMIT_EVENT = 'order-cancel-modal-submit';
export const GIFT_CARD_BALANCE_SUBMIT_EVENT = 'gift-card-balance-submit';
export const PRIMARY_HEADER_PROMO = {
    type: 'primary_header_promo',
    key: 'primaryHeaderPromo'
};
export const ALL_PROMO_TYPES = [
    {
        type: 'primary_header_promo',
        key: 'primaryHeaderPromo'
    },
    {
        type: 'secondary_header_promo',
        key: 'secondaryHeaderPromo'
    },
    {
        type: 'primary_footer_promo',
        key: 'primaryFooterPromo'
    },
    {
        type: 'secondary_footer_promos',
        key: 'secondaryFooterPromos'
    },
    {
        type: 'tertiary_footer_promo',
        key: 'tertiaryFooterPromo'
    }
];

export const MTO_TAB_INDICES = {
    QUICKSHIP: 0,
    CUSTOMIZE: 1
};

export const BACK_TO_CATALOG_DATA_KEY = 'backToCatalogData';
export const BACK_TO_CATALOG_DATA_TTL = 300;

export const FREQUENTLY_SELECTED_COUNTRIES = [
    'Canada',
    'Australia',
    'Japan',
    'Mexico',
    'Hong Kong',
    'Singapore',
    'United Kingdom',
    'Taiwan',
    'New Zealand',
    'Saudi Arabia'
];

export const PRODUCT_BOPIS_ORCHESTRATION_ROUTE = 'bopis';
export const PRODUCT_QUICKSHOP_ORCHESTRATION_ROUTE = 'quickshop';

export const TILE_TYPE_CONTENTFUL_SLUGS = {
    PDP_SHOP_THE_LOOK: 'pdpShopTheLookTileType',
    PDP_PRIMARY_RECOMMENDATIONS: 'pdpPrimaryRecommendationsTileType',
    PDP_SECONDARY_RECOMMENDATIONS: 'pdpSecondaryRecommendationsTileType',
    PDP_SOLD_OUT_RECOMMENDATIONS: 'pdpSoldOutTrayRecommendationsTileType'
};

export const CHAT_SETTINGS_BRAND_NAMES = {
    AN: 'Anthropologie',
    UO: 'UrbanOutfitters',
    FP: 'FreePeople'
};

export const DEFAULT_SELLER_CONTACT_TOPICS = {
    REQUEST_RETURN: 'request-return',
    ASK_QUESTION: 'ask-question'
};

export const MARKETPLACE_ERRORS = {
    MARKETPLACE_ERROR_400: 'contact-seller-modal-400-error',
    MARKETPLACE_ERROR_404: 'contact-seller-modal-404-error',
    MARKETPLACE_ERROR_500: 'contact-seller-modal-500-error',
    MARKETPLACE_ERROR_GENERAL: 'contact-seller-modal-general-error'
};

export const MARKETPLACE_ANALYTIC_ACTIONS = {
    SUCCESS: 'mrkt messaging success',
    FAILURE: 'mrkt messaging failure',
    ASK_QUESTION: 'mrkt ask seller a question',
    REQUEST_RETURN: 'mrkt request a return'
};

export const COUNTRIES_TO_OVERRIDE_DEFAULT_SITE_SWITCH_COUNTRY = ['NL'];

export const LOYALTY_LANDING_PATH = {
    UO: '/uo-rewards',
};

export const DEFAULT_LOYALTY_BIRTHYEAR = 1919;
export const DEFAULT_LOYALTY_TIER = 'Member';

// Order matters for display purposes in the write review template
// Saveable status sourced from URBN Docs
// http://docs.urbn.com/service/dev/v0/a15-profile#!/Traits/post_siteId_me_traits
export const BV_FIELD_DATA = [
    { name: 'age', saveable: true, showAutomatically: true },
    { name: 'beautyStyle', saveable: true, showAutomatically: true },
    { name: 'eyeColor', saveable: true, showAutomatically: true },
    { name: 'hairTexture', saveable: true, showAutomatically: true },
    { name: 'hairType', saveable: true, showAutomatically: true },
    { name: 'hairConcern', saveable: true, showAutomatically: true },
    { name: 'homeType', saveable: true, showAutomatically: true },
    { name: 'roomType', saveable: false, showAutomatically: true },
    { name: 'homePersonalStyle', saveable: true, showAutomatically: true },
    { name: 'skinTone', saveable: true, showAutomatically: true },
    { name: 'skinType', saveable: true, showAutomatically: true },
    { name: 'skinConcern', saveable: true, showAutomatically: true },
    // Not automatically shown, order doesn't matter
    // Inputs are created manually in the template
    { name: 'bodyType', saveable: true, showAutomatically: false },
    { name: 'heightFeet', saveable: true, showAutomatically: false },
    { name: 'heightInches', saveable: true, showAutomatically: false },
];
